/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarryForwardClaimBalancesRequest
 */
export interface CarryForwardClaimBalancesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CarryForwardClaimBalancesRequest
     */
    claimIds: Array<string>;
}

/**
 * Check if a given object implements the CarryForwardClaimBalancesRequest interface.
 */
export function instanceOfCarryForwardClaimBalancesRequest(value: object): value is CarryForwardClaimBalancesRequest {
    if (!('claimIds' in value) || value['claimIds'] === undefined) return false;
    return true;
}

export function CarryForwardClaimBalancesRequestFromJSON(json: any): CarryForwardClaimBalancesRequest {
    return CarryForwardClaimBalancesRequestFromJSONTyped(json, false);
}

export function CarryForwardClaimBalancesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarryForwardClaimBalancesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'claimIds': json['claimIds'],
    };
}

export function CarryForwardClaimBalancesRequestToJSON(json: any): CarryForwardClaimBalancesRequest {
    return CarryForwardClaimBalancesRequestToJSONTyped(json, false);
}

export function CarryForwardClaimBalancesRequestToJSONTyped(value?: CarryForwardClaimBalancesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimIds': value['claimIds'],
    };
}

